module.exports = __webpack_public_path__ + "img/tab.a3034f5b.png";